/**
 * @generated SignedSource<<19cf8c5556cf71441a61a78b00bc5bf5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LogicTreePageQuery$variables = {
  version: string;
};
export type LogicTreePageQuery$data = {
  readonly current_model_version: string | null | undefined;
  readonly get_model: {
    readonly gmm_logic_tree: {
      readonly branch_sets: ReadonlyArray<{
        readonly branches: ReadonlyArray<{
          readonly gsim_args: any | null | undefined;
          readonly gsim_name: string | null | undefined;
          readonly weight: number | null | undefined;
        } | null | undefined> | null | undefined;
        readonly long_name: string | null | undefined;
        readonly model_version: string | null | undefined;
        readonly short_name: string | null | undefined;
        readonly tectonic_region_type: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly id: string;
    } | null | undefined;
    readonly id: string;
    readonly source_logic_tree: {
      readonly branch_sets: ReadonlyArray<{
        readonly branches: ReadonlyArray<{
          readonly sources: ReadonlyArray<{
            readonly __typename: "BranchDistributedSource";
            readonly nrml_id: string | null | undefined;
          } | {
            readonly __typename: "BranchInversionSource";
            readonly inversion_id: string | null | undefined;
            readonly nrml_id: string | null | undefined;
            readonly rupture_set_id: string | null | undefined;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null | undefined> | null | undefined;
          readonly tag: string | null | undefined;
          readonly weight: number | null | undefined;
        } | null | undefined> | null | undefined;
        readonly id: string;
        readonly long_name: string | null | undefined;
        readonly short_name: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly id: string;
    } | null | undefined;
    readonly title: string | null | undefined;
    readonly version: string | null | undefined;
  } | null | undefined;
  readonly get_models: ReadonlyArray<{
    readonly id: string;
    readonly title: string | null | undefined;
    readonly version: string | null | undefined;
  } | null | undefined> | null | undefined;
};
export type LogicTreePageQuery = {
  response: LogicTreePageQuery$data;
  variables: LogicTreePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "version"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "version",
    "variableName": "version"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "model_version",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "short_name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "long_name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tectonic_region_type",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gsim_name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gsim_args",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "weight",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tag",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nrml_id",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "sources",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v13/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "inversion_id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rupture_set_id",
          "storageKey": null
        }
      ],
      "type": "BranchInversionSource",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v13/*: any*/)
      ],
      "type": "BranchDistributedSource",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "current_model_version",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "NshmModel",
  "kind": "LinkedField",
  "name": "get_models",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LogicTreePageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NshmModel",
        "kind": "LinkedField",
        "name": "get_model",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GroundMotionModelLogicTree",
            "kind": "LinkedField",
            "name": "gmm_logic_tree",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GmmBranchSet",
                "kind": "LinkedField",
                "name": "branch_sets",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GmmLogicTreeBranch",
                    "kind": "LinkedField",
                    "name": "branches",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SourceLogicTree",
            "kind": "LinkedField",
            "name": "source_logic_tree",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SourceBranchSet",
                "kind": "LinkedField",
                "name": "branch_sets",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SourceLogicTreeBranch",
                    "kind": "LinkedField",
                    "name": "branches",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      (v11/*: any*/),
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v15/*: any*/),
      (v16/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LogicTreePageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NshmModel",
        "kind": "LinkedField",
        "name": "get_model",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GroundMotionModelLogicTree",
            "kind": "LinkedField",
            "name": "gmm_logic_tree",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GmmBranchSet",
                "kind": "LinkedField",
                "name": "branch_sets",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GmmLogicTreeBranch",
                    "kind": "LinkedField",
                    "name": "branches",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SourceLogicTree",
            "kind": "LinkedField",
            "name": "source_logic_tree",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SourceBranchSet",
                "kind": "LinkedField",
                "name": "branch_sets",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SourceLogicTreeBranch",
                    "kind": "LinkedField",
                    "name": "branches",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      (v11/*: any*/),
                      (v14/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v15/*: any*/),
      (v16/*: any*/)
    ]
  },
  "params": {
    "cacheID": "37a4b1f5027dff7916c99d96d60a517c",
    "id": null,
    "metadata": {},
    "name": "LogicTreePageQuery",
    "operationKind": "query",
    "text": "query LogicTreePageQuery(\n  $version: String!\n) {\n  get_model(version: $version) {\n    id\n    version\n    title\n    gmm_logic_tree {\n      id\n      branch_sets {\n        model_version\n        short_name\n        long_name\n        tectonic_region_type\n        branches {\n          gsim_name\n          gsim_args\n          weight\n          id\n        }\n        id\n      }\n    }\n    source_logic_tree {\n      id\n      branch_sets {\n        id\n        short_name\n        long_name\n        branches {\n          tag\n          weight\n          sources {\n            __typename\n            ... on BranchInversionSource {\n              nrml_id\n              inversion_id\n              rupture_set_id\n            }\n            ... on BranchDistributedSource {\n              nrml_id\n            }\n          }\n          id\n        }\n      }\n    }\n  }\n  current_model_version\n  get_models {\n    id\n    version\n    title\n  }\n}\n"
  }
};
})();

(node as any).hash = "5384f0523789248adbaa7b3f47ef04c0";

export default node;
